module.exports = __webpack_public_path__ + "media/images/golden_pin_design_award_icon@2x-8fde4d5adc9c307f081fa974f0eb1779.png";